import MisInversiones from '../components/mercado/MisInversiones';

const Inversiones = () => <MisInversiones />;

export default Inversiones;
